import ROUTES from '../routes';
import RateRequest from '../hoc/rate-request/rate-request';
import RateRequestList from '../hoc/rate-request/list';
import RateRequestCreate from '../hoc/rate-request/create';
import RateRequestGeneral from '../hoc/rate-request/general';
import RateRequestItem from '../hoc/rate-request/item';

const RateRequestRoutes = {
  path: ROUTES.RATE_REQUEST,
  element: <RateRequest />,
  children: [
    {
      path: ROUTES.RATE_REQUEST_CURRENCY,
      element: <RateRequestList />,
      children: [
        {
          path: ROUTES.RATE_REQUEST_ADD,
          element: <RateRequestCreate />,
        },
        {
          path: ROUTES.RATE_REQUEST_GENERAL,
          element: <RateRequestGeneral />,
        },
        {
          path: ROUTES.RATE_REQUEST_EDIT,
          element: <RateRequestItem />,
        },
      ],
    },
  ],
};

export default RateRequestRoutes;
